import {useQuery} from '@tanstack/react-query';
import {api} from 'api/setup';
import {useAuth} from 'hooks';
import {useRouter} from 'next/router';
import {QueryKeyEnum} from 'types';

type CustomerPromo = {
  title: string;
  img: string;
  type: string;
  usage_limit: string;
  price_reduction: number | null;
  visible_before_date: string | null;
  min_requirement: number;
  promo_code: string;
  participants: string;
  details: string;
};

export const useCustomerPromos = () => {
  const {isAuthenticated} = useAuth();
  const {locale} = useRouter();

  return useQuery<CustomerPromo[]>({
    queryKey: [QueryKeyEnum.CUSTOMER_PROMOS, locale],
    queryFn: async () => await api.get('/customer/promocodes'),
    enabled: !!isAuthenticated,
    staleTime: 0,
  });
};
